import { useState, useEffect, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Footer from "./components/Footer";
import { prefetchRewardAd } from "./components/AdUnit";

// Lazy load components
const Home = lazy(() => import("./pages/Home"));
const GameDetails = lazy(() => import("./pages/GameDetails"));
const Contact = lazy(() => import("./pages/Contact"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));

// Simple loading fallback
const PageLoader = () => (
  <div className="flex-1 flex items-center justify-center py-20">
    <div className="w-8 h-8 border-4 border-indigo-500/20 border-t-indigo-500 rounded-full animate-spin" />
  </div>
);

function App() {
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const alreadyWatched = sessionStorage.getItem("reward_shown");
    if (!alreadyWatched) {
      prefetchRewardAd({
        onReward: () => sessionStorage.setItem("reward_shown", "true"),
        onClose: () => {},
      });
    }
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-inter selection:bg-indigo-500/30">
          {/* <Navbar searchQuery={searchQuery} onSearchChange={setSearchQuery} /> */}

          <main className="flex-1 overflow-x-hidden">
            {/* <Suspense fallback={<PageLoader />}> */}
            <Routes>
              <Route path="/" element={<Home searchQuery={searchQuery} />} />
              <Route path="/game/:slug" element={<GameDetails />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfUse />} />
            </Routes>
            {/* </Suspense> */}
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
